




































import { Component } from 'vue-property-decorator';
import json from '@/data/menu.json';
import popup from '@/data/popup.json';
import { TransitionType } from '@/config/enum';
import VModalConfirmation from '@/components/popup/VModalConfirmation.vue';
import VUserAvatar from '@/components/avatar/VUserAvatar.vue';
import menuModule from '@/store/modules/common/menu.module';
import popupModule from '@/store/modules/common/popup.module';
import Mixin from '@/mixin';
import authModule from '@/store/modules/common/auth.module';

@Component({
  name: 'VMenu',
  components: {
    VUserAvatar,
    VModalConfirmation
  }
})
export default class VMenu extends Mixin {
  public handleEvents(event: string): void {
    if (event === 'logout') {
      popupModule.initPopup(popup.logout);
      popupModule.setShowPopup(true);
    }
  }

  get transitionType() {
    if (menuModule.isShowMenu || false) {
      return TransitionType.slide_right;
    }
    return TransitionType.slide_left;
  }

  get isShowMenu(): boolean {
    return menuModule.isShowMenu || false;
  }

  get menus() {
    if (process.env.VUE_APP_FULL_MENU) return json.menu;
    return json.menu
      .filter(value => {
        return value.active;
      })
      .filter(value =>
        value?.role?.split(',').find(x => x === authModule.user?.role)
      );
  }

  public async closeMenu() {
    if (this.isSmallScreen()) {
      await menuModule.updateMenuStatus(!menuModule.isShowMenu);
    }
  }
}
